import type { ComponentType } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { appRoutes } from '../../shell/appRoutes';
import { InvitationsPage } from '../members/InvitationsPage';
import { MembersPage } from '../members/MembersPage';
import { AdminAccountsPage } from './AdminAccountsPage';
import { AdminAuditPage } from './AdminAuditPage';
import { AdminGeneralPage } from './AdminGeneralPage';
import { AdminGlobalRolesPage } from './AdminGlobalRolesPage';
import { AdminObserverOfficesPage } from './AdminObserverOfficesPage';
import { AdminRolesPage } from './AdminRolesPage';
import { AdminSignInPage } from './AdminSignInPage';
import { AdminWorkspacesPage } from './AdminWorkspacesPage';

/**
 * Розділи «Адміністрування» за сегментом адреси /admin/:section (прототип v4 adm-*, members у режимі адміністрування; облікові записи й
 * демо-офіси спостерігача — рішення 5 етапу 7).
 */
const PAGES: Record<string, ComponentType> = {
  members: MembersPage, invitations: InvitationsPage, roles: AdminRolesPage, 'global-roles': AdminGlobalRolesPage, accounts: AdminAccountsPage,
  workspaces: AdminWorkspacesPage, 'observer-offices': AdminObserverOfficesPage, 'sign-in': AdminSignInPage, general: AdminGeneralPage, audit: AdminAuditPage,
};

/** /admin/:section — розділ «Адміністрування»; невідомий розділ веде на огляд. */
export function AdminSectionPage() {
  const { section = '' } = useParams();
  const Page = PAGES[section];
  return Page ? <Page /> : <Navigate to={appRoutes.admin()} replace />;
}
